module.exports = __webpack_public_path__ + "static/media/logo_ard-wir-sind-deins.1bcee1a2.svg";